import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=b66cfd5c&scoped=true"
import script from "./BackHome.vue?vue&type=script&lang=js"
export * from "./BackHome.vue?vue&type=script&lang=js"
import style0 from "./BackHome.vue?vue&type=style&index=0&id=b66cfd5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66cfd5c",
  null
  
)

export default component.exports